import React from "react";

function ExchangeRate() {
  return <div>test</div>;
}

export default ExchangeRate;
